
































import { Component, InjectReactive, Vue } from "vue-property-decorator";
import { dateFormat } from "@/utils/setFormatDate";

@Component
export default class PickerInput extends Vue {
  @InjectReactive() readonly pIsMobile!: boolean;
  @InjectReactive() readonly pSelectedDate!: Date;

  today = new Date();

  get formatDate() {
    if (!this.pIsMobile) {
      return dateFormat.MMMM_YYYY(this.pSelectedDate);
    }

    const isToday =
      dateFormat.YYYY_MM_DD(this.pSelectedDate) ===
      dateFormat.YYYY_MM_DD(this.today);

    if (isToday) return "Сегодня";

    return dateFormat.D_DDDD(this.pSelectedDate);
  }
}
